'use client'

import { createContext, useContext, useMemo } from 'react'

type MaestroApplicationProviderProps = {
  children: React.ReactNode
  applicationSlug: string
}

type MaestroApplicationContextType = {
  applicationSlug: string
}

const MaestroApplicationContext = createContext<
  MaestroApplicationContextType | undefined
>(undefined)

const MaestroApplicationProvider: React.FC<MaestroApplicationProviderProps> = (props) => {
  const { children, applicationSlug } = props

  const value = useMemo(() => ({ applicationSlug }), [applicationSlug])

  return (
    <MaestroApplicationContext.Provider value={value}>
      {children}
    </MaestroApplicationContext.Provider>
  )
}

export const useMaestroApplicationSlug = (): string => {
  const context = useContext(MaestroApplicationContext)
  if (!context) {
    throw new Error(
      'useMaestroApplicationSlug must be used within a MaestroApplicationProvider',
    )
  }
  return context.applicationSlug
}

export default MaestroApplicationProvider
